
import { BaseConfigMerge } from "../table-config";
import { parseToTableFilterGroupDto, TableFilterGroup, TableFilterGroupDto } from "./table-filter-group.type";
import { BaseTableFilter } from "./table-filter.type";

// eslint-disable-next-line @tseslint/typedef
const TABLE_FILTER_CONFIG_DTO_DISCRIMINATOR = "table-filter-config";

export interface TableFilterConfig {
  filterGroups: TableFilterGroup[];
}
export interface TableFilterConfigDto {
  discriminator: typeof TABLE_FILTER_CONFIG_DTO_DISCRIMINATOR;
  filterGroups: TableFilterGroupDto[];
}
export interface TableFilterConfigPayloadDto {
  configJson: string;
}
export function parseToTableFilterConfigDto (filterConfig: TableFilterConfig): TableFilterConfigPayloadDto {
  return { configJson: JSON.stringify({ filterGroups: filterConfig.filterGroups.map(parseToTableFilterGroupDto), discriminator: TABLE_FILTER_CONFIG_DTO_DISCRIMINATOR } satisfies TableFilterConfigDto) };
}
export function mergeTableFilterConfig (filterConfig: TableFilterConfigDto | undefined, mergeBase: TableFilterConfig): TableFilterConfigMerge {
  let wasUpdated: boolean = false;

  const filterGroups: TableFilterGroup[] = [];

  for (const group of mergeBase.filterGroups) {
    const matchingGroup: TableFilterGroupDto | undefined = filterConfig?.filterGroups.find((groupDto: TableFilterGroupDto) => groupDto.selector === group.selector);

    if (!matchingGroup?.children) {
      filterGroups.push(group);
      wasUpdated = true;

      continue;
    }

    for (const filter of group.children) {
      const matchingFilter: BaseTableFilter | undefined = matchingGroup.children.find((baseFilter: BaseTableFilter) => baseFilter.selector === filter.selector);

      if (!matchingFilter) continue;

      filter.filterValue = matchingFilter.filterValue;
    }

    filterGroups.push(group);
  }

  return { wasUpdated, mergedConfig: { filterGroups } };
}
export interface TableFilterConfigMerge extends BaseConfigMerge {
  mergedConfig: TableFilterConfig;
}
export function isTableFilterConfigDto (value: unknown): value is TableFilterConfigDto {
  if (typeof value !== 'object' || !value) return false;

  if (!Object.hasOwn(value, 'discriminator')) return false;

  // eslint-disable-next-line @tseslint/no-explicit-any, @tseslint/no-unsafe-member-access
  return (value as any).discriminator === TABLE_FILTER_CONFIG_DTO_DISCRIMINATOR;
}
